import { StyleSheet } from 'react-native';
import { heightPercentageToDP as hp } from 'react-native-responsive-screen';

export const styles = StyleSheet.create({
  cardsContainerLarge: {
    flex: 1,
    marginBottom: hp('2%'),
    flexDirection: 'row',
    justifyContent: 'space-evenly',
  },
  cardColumnSmall: {
    marginTop: 5,
    flexDirection: 'column',
    marginBottom: 15,
  },
  cardColumnLarge: {
    flex: 1,
  },
});
